import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Patricia', 'Miguel', 'Carmen', 'Diego', 'Sofía', 'Fernando', 'Isabel', 'Ricardo'];
const CITIES = ['Buenos Aires', 'Madrid', 'México DF', 'Bogotá', 'Lima', 'Santiago', 'Barcelona', 'Montevideo'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 8000);
    // Repeat every 12 seconds (8s wait + 4s display)
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-3">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl p-4 border-l-4 border-green-500 flex items-center gap-3" data-id="element-4">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-5">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-6" />
          </div>
          <div data-id="element-7">
            <p className="text-sm font-semibold text-gray-800" data-id="element-8">
              {currentName} de {currentCity}
            </p>
            <p className="text-xs text-gray-600" data-id="element-9">
              acaba de comprar el MegaPack
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-10">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}